var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.enumCaptions),function(enumCaption){return (enumCaption.value == _vm.value)?_c('span',{class:'state-display-container' + ' ' + (_vm.customClass || ''),style:(enumCaption.style)},[_vm._v(_vm._s(enumCaption.caption)+"\n    ")]):_vm._e()}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b77a7c66","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/render/EnumRender.vue
// module id = null
// module chunks = 